export default {
  isVideo: (media) => {
    if (media) {
      if (media.url) {
        if (media.url.endsWith('.mp4')) {
          return true;
        }
      }
      if (media.content) {
        if (media.content.endsWith('.mp4')) {
          return true;
        }
      }
    }
    return false;
  },
  isVast: (media) => {
    return media.type && media.type === 'vast';
  },
  isVpaid: (media) => {
    return media.type && media.type === 'vpaid';
  },
  isEmbeddedPage: (media) => {
    return media.type && media.type === 'embedded-page';
  },
  injectCampaignUuid: (content, campaignUuid) => {
    const regExp = /(?:\[ATR_UUID\])/g;
    return content.replace(regExp, campaignUuid);
  },
  validateUrl(value) {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
      value
    );
  },
  validCpf: function (cpf) {
    if (
      !cpf ||
      cpf.length !== 11 ||
      cpf === '00000000000' ||
      cpf === '11111111111' ||
      cpf === '22222222222' ||
      cpf === '33333333333' ||
      cpf === '44444444444' ||
      cpf === '55555555555' ||
      cpf === '66666666666' ||
      cpf === '77777777777' ||
      cpf === '88888888888' ||
      cpf === '99999999999'
    )
      return false;
    var soma = 0;
    var resto;
    for (var i = 1; i <= 9; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (var i = 1; i <= 10; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;
    return true;
  },
  clearFormat: (value, fieldType) => {
    if (fieldType === 'cpf' && value) {
      return value.replace(/\./g, '').replace(/-/g, '');
    } else if (fieldType === 'phone' && value) {
      return value
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .replace(/-/g, '')
        .replace(' ', '');
    }
    return value;
  },
  validateConnection: () => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      var file =
        'https://s3.amazonaws.com/artemis-prd-files-static.mobicare.com.br/static/e.gif';
      var randomNum = Math.round(Math.random() * 10000);

      xhr.open('HEAD', file + '?rand=' + randomNum, true);
      xhr.send();

      xhr.addEventListener('readystatechange', processRequest, false);

      function processRequest(e) {
        if (xhr.readyState === 4) {
          if (xhr.status >= 200 && xhr.status < 304) {
            resolve('connection exists!');
          } else {
            reject("connection doesn't exist!");
          }
        }
      }
    });
  },
  sleep: (milliseconds) => {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  },
};
